export enum STATUS_PRIVATE_OFFICE {
  AVAILABLE = 0,
  NOT_AVAILABLE = 1,
  OCCUPED_WITH_WOBA_CLIENT = 2,
  AVAILABLE_WITHOUT_TP = 3,
  NOT_AVAILABLE_WITHOUT_TP = 4,
  RESERVED = 5,
  DELETED = 6,
}

export enum STATUS_PRIVATE_OFFICE_UPDATED_DAYS {
  DEFAULT = 1,
  WARNING = 2,
  DANGER = 3,
}

export const STATUS_PRIVATE_OFFICE_UPDATED_DAYS_NAMES = {
  DANGER: {
    title: "Danger",
    badge_color: "red_400",
  },
  WARNING: {
    title: "Warning",
    badge_color: "orange_400",
  },
  DEFAULT: {
    title: "Atualizada",
    badge_color: "green_300",
  },
};

export const STATUS_PRIVATE_OFFICE_NAMES = {
  AVAILABLE: {
    title: "Disponível",
    badge_color: "green_400",
  },
  NOT_AVAILABLE: {
    title: "Indisponível",
    badge_color: "red_400",
  },
  OCCUPED_WITH_WOBA_CLIENT: {
    title: "Ocupado com cliente Woba",
    badge_color: "yellow_400",
  },
  AVAILABLE_WITHOUT_TP: {
    title: "Disponível sem TP",
    badge_color: "green_300",
  },
  NOT_AVAILABLE_WITHOUT_TP: {
    title: "Indisponível sem TP",
    badge_color: "red_300",
  },
  RESERVED: {
    title: "Reservado",
    badge_color: "orange_400",
  },
  DELETED: {
    title: "Removida",
    badge_color: "red_400",
  },
};
